/*
 * @Author: Wu Yinglei
 * @Date: 2021-08-12 13:41:31
 * @LastEditors: Wu Yinglei
 * @LastEditTime: 2021-08-23 14:10:14
 * @Description:
 * @FilePath: \lab820\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/views/home'
// import mindex from '@/views/mhome'
Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'Home',
    //   components: {
    //     default: () => import('@/views/home'),
    //     pc: () => import('@/views/home'),
    //     m: () => import('@/views/mhome')
    //   }
    // },
    {
      path: '/IMMUNE',
      name: 'immune',
      component: () => import('@/views/immune'),
    },
    {
      path: '/STEM',
      name: 'stem',
      component: () => import('@/views/stem'),
    },
    {
      path: '/REFUND',
      name: 'refund',
      component: () => import('@/views/refund'),
    },
    {
      path: '/Profile',
      name: 'Profile',
      component: () => import('@/views/profile'),
    },
    {
      path: "/EsignSuccess",
      name: 'EsignSuccess',
      component: () => import('@/views/esign/success'),
    },
    {
      path: "/EsignMiddle",
      name: 'EsignMiddle',
      component: () => import('@/views/esign/middle'),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js